import * as React from 'react';
import './ProductSecondaryImages.styles.less';
import {IProductSecondaryImagesProps} from "./ProductSecondaryImages.types";
import { Col, Row } from 'antd';
import { imageUrl } from 'theme/libs/util';

export const ProductSecondaryImages = (props:IProductSecondaryImagesProps) => {
    return (
        <div className='secondary-image-slot'>
            <Row gutter={[8, 8]}>
            {props.secondaryImages.map((img:any, i:number) => {
                return <Col key={i} xs={12} md={6} className="media-item fullframe"><>
                    {props.hasZoom === true ? 
                    <>
                        <figure
                            className="zoom"
                            onMouseMove={props.zoom}
                            style={{backgroundImage: `url(${imageUrl(img, { y: 1300, x:1100, t: 'image/png' })})` }}
                        >
                            <img
                                className="fullFrame lazy"
                                src={imageUrl(img, { t: "image/jpeg" })}
                                onClick={props.openSecondaryModal(img.mediaId)}
                            />
                        </figure>
                    </>
                    :
                    <>
                        <img
                            className="fullFrame lazy nozoom"
                            src={imageUrl(img, { t: "image/jpeg" })}
                            onClick={props.openSecondaryModal(img.mediaId)}
                        />
                    </>
                    }
                </></Col>
            }
            )} 
            </Row>     
        </div>
    )
}